package com.shadowings.gero

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        document.getElementById("loader")?.let { it.parentNode?.removeChild(it) }
        Firebase.initialize(
            options = FirebaseOptions(
                applicationId = "1:1007297812241:web:89b4d2b146d02d6e821eb0",
                apiKey = "AIzaSyDVWCQbTyK3monHD3wMH_yxE8kKmK8Div0",
                projectId = "renenet-f2b0f",
                storageBucket = "renenet-f2b0f.firebasestorage.app",
                gcmSenderId = "1007297812241",
                authDomain = "renenet-f2b0f.firebaseapp.com",
            )
        )
        initKoin()
        val root =
            document.getElementById("root") ?: document.body ?: error("Root element not found")
        ComposeViewport(root) {
            App(
                initialThemeMode = com.shadowings.gero.domain.model.ThemeMode.System
            )
        }
    }
}

